/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TodayRouteImport } from './routes/today'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as OldLoginRouteImport } from './routes/old-login'
import { Route as LoginGredirRouteImport } from './routes/login-gredir'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CaptureAppRouteImport } from './routes/capture-app'
import { Route as CaptureRouteImport } from './routes/capture'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VenuesIndexRouteImport } from './routes/venues/index'
import { Route as FaqIndexRouteImport } from './routes/faq/index'
import { Route as EmbedIndexRouteImport } from './routes/embed/index'
import { Route as Demo1IndexRouteImport } from './routes/demo1/index'
import { Route as ConferenceIndexRouteImport } from './routes/conference/index'
import { Route as WatchJoinRouteImport } from './routes/watch/join'
import { Route as WatchPlaceIdOrCodeRouteImport } from './routes/watch/$placeIdOrCode'
import { Route as VenuesAddTeamRouteImport } from './routes/venues/add-team'
import { Route as VenuesAddPlaceRouteImport } from './routes/venues/add-place'
import { Route as TestFunformmodalRouteImport } from './routes/test/funformmodal'
import { Route as TestFunformRouteImport } from './routes/test/funform'
import { Route as TeamAddTeamRouteImport } from './routes/team/add-team'
import { Route as TTeamIdRouteImport } from './routes/t/$teamId'
import { Route as QuickStartRouteImport } from './routes/quick.start'
import { Route as PlacesWebcamCaptureRouteImport } from './routes/places/webcam-capture'
import { Route as PlacesScreenCaptureRouteImport } from './routes/places/screen-capture'
import { Route as PlacesNewRouteImport } from './routes/places/new'
import { Route as LoginFromEmailRouteImport } from './routes/login.fromEmail'
import { Route as FaqCaptureRouteImport } from './routes/faq/capture'
import { Route as EncoderEncoderIdRouteImport } from './routes/encoder/$encoderId'
import { Route as FaqTermsIndexRouteImport } from './routes/faq/terms/index'
import { Route as FaqPrivacyIndexRouteImport } from './routes/faq/privacy/index'
import { Route as TeamTeamIdManageRouteImport } from './routes/team/$teamId/manage'
import { Route as EmbedPlaceIdOrCodeLatestRouteImport } from './routes/embed/$placeIdOrCode/latest'
import { Route as TeamTeamIdPlacePlaceIdRouteImport } from './routes/team/$teamId/place/$placeId'

const TodayRoute = TodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const OldLoginRoute = OldLoginRouteImport.update({
  id: '/old-login',
  path: '/old-login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginGredirRoute = LoginGredirRouteImport.update({
  id: '/login-gredir',
  path: '/login-gredir',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CaptureAppRoute = CaptureAppRouteImport.update({
  id: '/capture-app',
  path: '/capture-app',
  getParentRoute: () => rootRouteImport,
} as any)
const CaptureRoute = CaptureRouteImport.update({
  id: '/capture',
  path: '/capture',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesIndexRoute = VenuesIndexRouteImport.update({
  id: '/venues/',
  path: '/venues/',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqIndexRoute = FaqIndexRouteImport.update({
  id: '/faq/',
  path: '/faq/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedIndexRoute = EmbedIndexRouteImport.update({
  id: '/embed/',
  path: '/embed/',
  getParentRoute: () => rootRouteImport,
} as any)
const Demo1IndexRoute = Demo1IndexRouteImport.update({
  id: '/demo1/',
  path: '/demo1/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConferenceIndexRoute = ConferenceIndexRouteImport.update({
  id: '/conference/',
  path: '/conference/',
  getParentRoute: () => rootRouteImport,
} as any)
const WatchJoinRoute = WatchJoinRouteImport.update({
  id: '/watch/join',
  path: '/watch/join',
  getParentRoute: () => rootRouteImport,
} as any)
const WatchPlaceIdOrCodeRoute = WatchPlaceIdOrCodeRouteImport.update({
  id: '/watch/$placeIdOrCode',
  path: '/watch/$placeIdOrCode',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesAddTeamRoute = VenuesAddTeamRouteImport.update({
  id: '/venues/add-team',
  path: '/venues/add-team',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesAddPlaceRoute = VenuesAddPlaceRouteImport.update({
  id: '/venues/add-place',
  path: '/venues/add-place',
  getParentRoute: () => rootRouteImport,
} as any)
const TestFunformmodalRoute = TestFunformmodalRouteImport.update({
  id: '/test/funformmodal',
  path: '/test/funformmodal',
  getParentRoute: () => rootRouteImport,
} as any)
const TestFunformRoute = TestFunformRouteImport.update({
  id: '/test/funform',
  path: '/test/funform',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamAddTeamRoute = TeamAddTeamRouteImport.update({
  id: '/team/add-team',
  path: '/team/add-team',
  getParentRoute: () => rootRouteImport,
} as any)
const TTeamIdRoute = TTeamIdRouteImport.update({
  id: '/t/$teamId',
  path: '/t/$teamId',
  getParentRoute: () => rootRouteImport,
} as any)
const QuickStartRoute = QuickStartRouteImport.update({
  id: '/quick/start',
  path: '/quick/start',
  getParentRoute: () => rootRouteImport,
} as any)
const PlacesWebcamCaptureRoute = PlacesWebcamCaptureRouteImport.update({
  id: '/places/webcam-capture',
  path: '/places/webcam-capture',
  getParentRoute: () => rootRouteImport,
} as any)
const PlacesScreenCaptureRoute = PlacesScreenCaptureRouteImport.update({
  id: '/places/screen-capture',
  path: '/places/screen-capture',
  getParentRoute: () => rootRouteImport,
} as any)
const PlacesNewRoute = PlacesNewRouteImport.update({
  id: '/places/new',
  path: '/places/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginFromEmailRoute = LoginFromEmailRouteImport.update({
  id: '/fromEmail',
  path: '/fromEmail',
  getParentRoute: () => LoginRoute,
} as any)
const FaqCaptureRoute = FaqCaptureRouteImport.update({
  id: '/faq/capture',
  path: '/faq/capture',
  getParentRoute: () => rootRouteImport,
} as any)
const EncoderEncoderIdRoute = EncoderEncoderIdRouteImport.update({
  id: '/encoder/$encoderId',
  path: '/encoder/$encoderId',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqTermsIndexRoute = FaqTermsIndexRouteImport.update({
  id: '/faq/terms/',
  path: '/faq/terms/',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqPrivacyIndexRoute = FaqPrivacyIndexRouteImport.update({
  id: '/faq/privacy/',
  path: '/faq/privacy/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamTeamIdManageRoute = TeamTeamIdManageRouteImport.update({
  id: '/team/$teamId/manage',
  path: '/team/$teamId/manage',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedPlaceIdOrCodeLatestRoute =
  EmbedPlaceIdOrCodeLatestRouteImport.update({
    id: '/embed/$placeIdOrCode/latest',
    path: '/embed/$placeIdOrCode/latest',
    getParentRoute: () => rootRouteImport,
  } as any)
const TeamTeamIdPlacePlaceIdRoute = TeamTeamIdPlacePlaceIdRouteImport.update({
  id: '/team/$teamId/place/$placeId',
  path: '/team/$teamId/place/$placeId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/capture': typeof CaptureRoute
  '/capture-app': typeof CaptureAppRoute
  '/login': typeof LoginRouteWithChildren
  '/login-gredir': typeof LoginGredirRoute
  '/old-login': typeof OldLoginRoute
  '/signup': typeof SignupRoute
  '/today': typeof TodayRoute
  '/encoder/$encoderId': typeof EncoderEncoderIdRoute
  '/faq/capture': typeof FaqCaptureRoute
  '/login/fromEmail': typeof LoginFromEmailRoute
  '/places/new': typeof PlacesNewRoute
  '/places/screen-capture': typeof PlacesScreenCaptureRoute
  '/places/webcam-capture': typeof PlacesWebcamCaptureRoute
  '/quick/start': typeof QuickStartRoute
  '/t/$teamId': typeof TTeamIdRoute
  '/team/add-team': typeof TeamAddTeamRoute
  '/test/funform': typeof TestFunformRoute
  '/test/funformmodal': typeof TestFunformmodalRoute
  '/venues/add-place': typeof VenuesAddPlaceRoute
  '/venues/add-team': typeof VenuesAddTeamRoute
  '/watch/$placeIdOrCode': typeof WatchPlaceIdOrCodeRoute
  '/watch/join': typeof WatchJoinRoute
  '/conference/': typeof ConferenceIndexRoute
  '/demo1/': typeof Demo1IndexRoute
  '/embed/': typeof EmbedIndexRoute
  '/faq/': typeof FaqIndexRoute
  '/venues/': typeof VenuesIndexRoute
  '/embed/$placeIdOrCode/latest': typeof EmbedPlaceIdOrCodeLatestRoute
  '/team/$teamId/manage': typeof TeamTeamIdManageRoute
  '/faq/privacy/': typeof FaqPrivacyIndexRoute
  '/faq/terms/': typeof FaqTermsIndexRoute
  '/team/$teamId/place/$placeId': typeof TeamTeamIdPlacePlaceIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/capture': typeof CaptureRoute
  '/capture-app': typeof CaptureAppRoute
  '/login': typeof LoginRouteWithChildren
  '/login-gredir': typeof LoginGredirRoute
  '/old-login': typeof OldLoginRoute
  '/signup': typeof SignupRoute
  '/today': typeof TodayRoute
  '/encoder/$encoderId': typeof EncoderEncoderIdRoute
  '/faq/capture': typeof FaqCaptureRoute
  '/login/fromEmail': typeof LoginFromEmailRoute
  '/places/new': typeof PlacesNewRoute
  '/places/screen-capture': typeof PlacesScreenCaptureRoute
  '/places/webcam-capture': typeof PlacesWebcamCaptureRoute
  '/quick/start': typeof QuickStartRoute
  '/t/$teamId': typeof TTeamIdRoute
  '/team/add-team': typeof TeamAddTeamRoute
  '/test/funform': typeof TestFunformRoute
  '/test/funformmodal': typeof TestFunformmodalRoute
  '/venues/add-place': typeof VenuesAddPlaceRoute
  '/venues/add-team': typeof VenuesAddTeamRoute
  '/watch/$placeIdOrCode': typeof WatchPlaceIdOrCodeRoute
  '/watch/join': typeof WatchJoinRoute
  '/conference': typeof ConferenceIndexRoute
  '/demo1': typeof Demo1IndexRoute
  '/embed': typeof EmbedIndexRoute
  '/faq': typeof FaqIndexRoute
  '/venues': typeof VenuesIndexRoute
  '/embed/$placeIdOrCode/latest': typeof EmbedPlaceIdOrCodeLatestRoute
  '/team/$teamId/manage': typeof TeamTeamIdManageRoute
  '/faq/privacy': typeof FaqPrivacyIndexRoute
  '/faq/terms': typeof FaqTermsIndexRoute
  '/team/$teamId/place/$placeId': typeof TeamTeamIdPlacePlaceIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/capture': typeof CaptureRoute
  '/capture-app': typeof CaptureAppRoute
  '/login': typeof LoginRouteWithChildren
  '/login-gredir': typeof LoginGredirRoute
  '/old-login': typeof OldLoginRoute
  '/signup': typeof SignupRoute
  '/today': typeof TodayRoute
  '/encoder/$encoderId': typeof EncoderEncoderIdRoute
  '/faq/capture': typeof FaqCaptureRoute
  '/login/fromEmail': typeof LoginFromEmailRoute
  '/places/new': typeof PlacesNewRoute
  '/places/screen-capture': typeof PlacesScreenCaptureRoute
  '/places/webcam-capture': typeof PlacesWebcamCaptureRoute
  '/quick/start': typeof QuickStartRoute
  '/t/$teamId': typeof TTeamIdRoute
  '/team/add-team': typeof TeamAddTeamRoute
  '/test/funform': typeof TestFunformRoute
  '/test/funformmodal': typeof TestFunformmodalRoute
  '/venues/add-place': typeof VenuesAddPlaceRoute
  '/venues/add-team': typeof VenuesAddTeamRoute
  '/watch/$placeIdOrCode': typeof WatchPlaceIdOrCodeRoute
  '/watch/join': typeof WatchJoinRoute
  '/conference/': typeof ConferenceIndexRoute
  '/demo1/': typeof Demo1IndexRoute
  '/embed/': typeof EmbedIndexRoute
  '/faq/': typeof FaqIndexRoute
  '/venues/': typeof VenuesIndexRoute
  '/embed/$placeIdOrCode/latest': typeof EmbedPlaceIdOrCodeLatestRoute
  '/team/$teamId/manage': typeof TeamTeamIdManageRoute
  '/faq/privacy/': typeof FaqPrivacyIndexRoute
  '/faq/terms/': typeof FaqTermsIndexRoute
  '/team/$teamId/place/$placeId': typeof TeamTeamIdPlacePlaceIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/capture'
    | '/capture-app'
    | '/login'
    | '/login-gredir'
    | '/old-login'
    | '/signup'
    | '/today'
    | '/encoder/$encoderId'
    | '/faq/capture'
    | '/login/fromEmail'
    | '/places/new'
    | '/places/screen-capture'
    | '/places/webcam-capture'
    | '/quick/start'
    | '/t/$teamId'
    | '/team/add-team'
    | '/test/funform'
    | '/test/funformmodal'
    | '/venues/add-place'
    | '/venues/add-team'
    | '/watch/$placeIdOrCode'
    | '/watch/join'
    | '/conference/'
    | '/demo1/'
    | '/embed/'
    | '/faq/'
    | '/venues/'
    | '/embed/$placeIdOrCode/latest'
    | '/team/$teamId/manage'
    | '/faq/privacy/'
    | '/faq/terms/'
    | '/team/$teamId/place/$placeId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/capture'
    | '/capture-app'
    | '/login'
    | '/login-gredir'
    | '/old-login'
    | '/signup'
    | '/today'
    | '/encoder/$encoderId'
    | '/faq/capture'
    | '/login/fromEmail'
    | '/places/new'
    | '/places/screen-capture'
    | '/places/webcam-capture'
    | '/quick/start'
    | '/t/$teamId'
    | '/team/add-team'
    | '/test/funform'
    | '/test/funformmodal'
    | '/venues/add-place'
    | '/venues/add-team'
    | '/watch/$placeIdOrCode'
    | '/watch/join'
    | '/conference'
    | '/demo1'
    | '/embed'
    | '/faq'
    | '/venues'
    | '/embed/$placeIdOrCode/latest'
    | '/team/$teamId/manage'
    | '/faq/privacy'
    | '/faq/terms'
    | '/team/$teamId/place/$placeId'
  id:
    | '__root__'
    | '/'
    | '/capture'
    | '/capture-app'
    | '/login'
    | '/login-gredir'
    | '/old-login'
    | '/signup'
    | '/today'
    | '/encoder/$encoderId'
    | '/faq/capture'
    | '/login/fromEmail'
    | '/places/new'
    | '/places/screen-capture'
    | '/places/webcam-capture'
    | '/quick/start'
    | '/t/$teamId'
    | '/team/add-team'
    | '/test/funform'
    | '/test/funformmodal'
    | '/venues/add-place'
    | '/venues/add-team'
    | '/watch/$placeIdOrCode'
    | '/watch/join'
    | '/conference/'
    | '/demo1/'
    | '/embed/'
    | '/faq/'
    | '/venues/'
    | '/embed/$placeIdOrCode/latest'
    | '/team/$teamId/manage'
    | '/faq/privacy/'
    | '/faq/terms/'
    | '/team/$teamId/place/$placeId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CaptureRoute: typeof CaptureRoute
  CaptureAppRoute: typeof CaptureAppRoute
  LoginRoute: typeof LoginRouteWithChildren
  LoginGredirRoute: typeof LoginGredirRoute
  OldLoginRoute: typeof OldLoginRoute
  SignupRoute: typeof SignupRoute
  TodayRoute: typeof TodayRoute
  EncoderEncoderIdRoute: typeof EncoderEncoderIdRoute
  FaqCaptureRoute: typeof FaqCaptureRoute
  PlacesNewRoute: typeof PlacesNewRoute
  PlacesScreenCaptureRoute: typeof PlacesScreenCaptureRoute
  PlacesWebcamCaptureRoute: typeof PlacesWebcamCaptureRoute
  QuickStartRoute: typeof QuickStartRoute
  TTeamIdRoute: typeof TTeamIdRoute
  TeamAddTeamRoute: typeof TeamAddTeamRoute
  TestFunformRoute: typeof TestFunformRoute
  TestFunformmodalRoute: typeof TestFunformmodalRoute
  VenuesAddPlaceRoute: typeof VenuesAddPlaceRoute
  VenuesAddTeamRoute: typeof VenuesAddTeamRoute
  WatchPlaceIdOrCodeRoute: typeof WatchPlaceIdOrCodeRoute
  WatchJoinRoute: typeof WatchJoinRoute
  ConferenceIndexRoute: typeof ConferenceIndexRoute
  Demo1IndexRoute: typeof Demo1IndexRoute
  EmbedIndexRoute: typeof EmbedIndexRoute
  FaqIndexRoute: typeof FaqIndexRoute
  VenuesIndexRoute: typeof VenuesIndexRoute
  EmbedPlaceIdOrCodeLatestRoute: typeof EmbedPlaceIdOrCodeLatestRoute
  TeamTeamIdManageRoute: typeof TeamTeamIdManageRoute
  FaqPrivacyIndexRoute: typeof FaqPrivacyIndexRoute
  FaqTermsIndexRoute: typeof FaqTermsIndexRoute
  TeamTeamIdPlacePlaceIdRoute: typeof TeamTeamIdPlacePlaceIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/today': {
      id: '/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof TodayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/old-login': {
      id: '/old-login'
      path: '/old-login'
      fullPath: '/old-login'
      preLoaderRoute: typeof OldLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-gredir': {
      id: '/login-gredir'
      path: '/login-gredir'
      fullPath: '/login-gredir'
      preLoaderRoute: typeof LoginGredirRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capture-app': {
      id: '/capture-app'
      path: '/capture-app'
      fullPath: '/capture-app'
      preLoaderRoute: typeof CaptureAppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capture': {
      id: '/capture'
      path: '/capture'
      fullPath: '/capture'
      preLoaderRoute: typeof CaptureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/': {
      id: '/venues/'
      path: '/venues'
      fullPath: '/venues/'
      preLoaderRoute: typeof VenuesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/': {
      id: '/faq/'
      path: '/faq'
      fullPath: '/faq/'
      preLoaderRoute: typeof FaqIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/': {
      id: '/embed/'
      path: '/embed'
      fullPath: '/embed/'
      preLoaderRoute: typeof EmbedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo1/': {
      id: '/demo1/'
      path: '/demo1'
      fullPath: '/demo1/'
      preLoaderRoute: typeof Demo1IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conference/': {
      id: '/conference/'
      path: '/conference'
      fullPath: '/conference/'
      preLoaderRoute: typeof ConferenceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/watch/join': {
      id: '/watch/join'
      path: '/watch/join'
      fullPath: '/watch/join'
      preLoaderRoute: typeof WatchJoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/watch/$placeIdOrCode': {
      id: '/watch/$placeIdOrCode'
      path: '/watch/$placeIdOrCode'
      fullPath: '/watch/$placeIdOrCode'
      preLoaderRoute: typeof WatchPlaceIdOrCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/add-team': {
      id: '/venues/add-team'
      path: '/venues/add-team'
      fullPath: '/venues/add-team'
      preLoaderRoute: typeof VenuesAddTeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/add-place': {
      id: '/venues/add-place'
      path: '/venues/add-place'
      fullPath: '/venues/add-place'
      preLoaderRoute: typeof VenuesAddPlaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/funformmodal': {
      id: '/test/funformmodal'
      path: '/test/funformmodal'
      fullPath: '/test/funformmodal'
      preLoaderRoute: typeof TestFunformmodalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/funform': {
      id: '/test/funform'
      path: '/test/funform'
      fullPath: '/test/funform'
      preLoaderRoute: typeof TestFunformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/add-team': {
      id: '/team/add-team'
      path: '/team/add-team'
      fullPath: '/team/add-team'
      preLoaderRoute: typeof TeamAddTeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t/$teamId': {
      id: '/t/$teamId'
      path: '/t/$teamId'
      fullPath: '/t/$teamId'
      preLoaderRoute: typeof TTeamIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quick/start': {
      id: '/quick/start'
      path: '/quick/start'
      fullPath: '/quick/start'
      preLoaderRoute: typeof QuickStartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/places/webcam-capture': {
      id: '/places/webcam-capture'
      path: '/places/webcam-capture'
      fullPath: '/places/webcam-capture'
      preLoaderRoute: typeof PlacesWebcamCaptureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/places/screen-capture': {
      id: '/places/screen-capture'
      path: '/places/screen-capture'
      fullPath: '/places/screen-capture'
      preLoaderRoute: typeof PlacesScreenCaptureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/places/new': {
      id: '/places/new'
      path: '/places/new'
      fullPath: '/places/new'
      preLoaderRoute: typeof PlacesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/fromEmail': {
      id: '/login/fromEmail'
      path: '/fromEmail'
      fullPath: '/login/fromEmail'
      preLoaderRoute: typeof LoginFromEmailRouteImport
      parentRoute: typeof LoginRoute
    }
    '/faq/capture': {
      id: '/faq/capture'
      path: '/faq/capture'
      fullPath: '/faq/capture'
      preLoaderRoute: typeof FaqCaptureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/encoder/$encoderId': {
      id: '/encoder/$encoderId'
      path: '/encoder/$encoderId'
      fullPath: '/encoder/$encoderId'
      preLoaderRoute: typeof EncoderEncoderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/terms/': {
      id: '/faq/terms/'
      path: '/faq/terms'
      fullPath: '/faq/terms/'
      preLoaderRoute: typeof FaqTermsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/privacy/': {
      id: '/faq/privacy/'
      path: '/faq/privacy'
      fullPath: '/faq/privacy/'
      preLoaderRoute: typeof FaqPrivacyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/$teamId/manage': {
      id: '/team/$teamId/manage'
      path: '/team/$teamId/manage'
      fullPath: '/team/$teamId/manage'
      preLoaderRoute: typeof TeamTeamIdManageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/$placeIdOrCode/latest': {
      id: '/embed/$placeIdOrCode/latest'
      path: '/embed/$placeIdOrCode/latest'
      fullPath: '/embed/$placeIdOrCode/latest'
      preLoaderRoute: typeof EmbedPlaceIdOrCodeLatestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/$teamId/place/$placeId': {
      id: '/team/$teamId/place/$placeId'
      path: '/team/$teamId/place/$placeId'
      fullPath: '/team/$teamId/place/$placeId'
      preLoaderRoute: typeof TeamTeamIdPlacePlaceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface LoginRouteChildren {
  LoginFromEmailRoute: typeof LoginFromEmailRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginFromEmailRoute: LoginFromEmailRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CaptureRoute: CaptureRoute,
  CaptureAppRoute: CaptureAppRoute,
  LoginRoute: LoginRouteWithChildren,
  LoginGredirRoute: LoginGredirRoute,
  OldLoginRoute: OldLoginRoute,
  SignupRoute: SignupRoute,
  TodayRoute: TodayRoute,
  EncoderEncoderIdRoute: EncoderEncoderIdRoute,
  FaqCaptureRoute: FaqCaptureRoute,
  PlacesNewRoute: PlacesNewRoute,
  PlacesScreenCaptureRoute: PlacesScreenCaptureRoute,
  PlacesWebcamCaptureRoute: PlacesWebcamCaptureRoute,
  QuickStartRoute: QuickStartRoute,
  TTeamIdRoute: TTeamIdRoute,
  TeamAddTeamRoute: TeamAddTeamRoute,
  TestFunformRoute: TestFunformRoute,
  TestFunformmodalRoute: TestFunformmodalRoute,
  VenuesAddPlaceRoute: VenuesAddPlaceRoute,
  VenuesAddTeamRoute: VenuesAddTeamRoute,
  WatchPlaceIdOrCodeRoute: WatchPlaceIdOrCodeRoute,
  WatchJoinRoute: WatchJoinRoute,
  ConferenceIndexRoute: ConferenceIndexRoute,
  Demo1IndexRoute: Demo1IndexRoute,
  EmbedIndexRoute: EmbedIndexRoute,
  FaqIndexRoute: FaqIndexRoute,
  VenuesIndexRoute: VenuesIndexRoute,
  EmbedPlaceIdOrCodeLatestRoute: EmbedPlaceIdOrCodeLatestRoute,
  TeamTeamIdManageRoute: TeamTeamIdManageRoute,
  FaqPrivacyIndexRoute: FaqPrivacyIndexRoute,
  FaqTermsIndexRoute: FaqTermsIndexRoute,
  TeamTeamIdPlacePlaceIdRoute: TeamTeamIdPlacePlaceIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
